import { ModalCloseButton } from "@towersystems/roam-common-native";
import React from "react";

export const useActionBackOrClose = (navigation: any) => {
  React.useEffect(() => {
    if (navigation.getState().routes.length <= 1) {
      navigation.setOptions({
        headerLeft: () => <ModalCloseButton type="Close" />,
      });
    }
  }, []);
};
